<form [formGroup]="feedbackForm">
    <h3>{{ moodTitle }}</h3>
    <div class="feedbackForm__mood" [ngClass]="{ active: feedbackForm.get('mood').value !== null }">
        @for (option of moodOptions; track option) {
            <label
                tabindex="0"
                [for]="option.id"
                [attr.aria-label]="'mijn-feedback.label.' + option.id | apContent"
                role="button"
                (keydown.enter)="onMoodChange(option.value)"
                (keydown.space)="onMoodChange(option.value)"
            >
                <input tabindex="-1" type="radio" [id]="option.id" [value]="option.value" apInputRef formControlName="mood" />
                <span
                    class="feedbackForm__mood__icon"
                    [apInlineSVG]="getSvgSource(option.id)"
                    [setSVGAttributes]="{ width: '24px', height: '24px' }"
                >
                </span>
                <span class="feedbackForm__mood__label">{{ 'mijn-feedback.label.' + option.id | apContent }}</span>
            </label>
        }
        <ap-form-errors [control]="getFormControl('mood')" [messages]="moodErrorMessages"></ap-form-errors>
    </div>

    @if (hasMoodValue()) {
        <h3>{{ commentsTitle }}</h3>
        <div role="status" class="ap-sr-only">{{ commentsTitle }}</div>
        <div>
            <p>
                {{ 'mijn-feedback.feedbackForm.info' | apContent }}
            </p>
            <ap-textarea
                [attr.aria-label]="getAriaLabelComments()"
                [formControl]="getFormControl('comments')"
                [messages]="commentsErrorMessages"
                [maxCharacters]="maxCharacters"
                apInputConstraint
            >
            </ap-textarea>
            <p>
                {{ 'mijn-feedback.feedbackForm.button-info' | apContent }}
                <ap-button
                    [ariaLabel]="getAriaLabelContactButton()"
                    type="button"
                    (onClick)="onContact()"
                    [text]="true"
                    data-bb="contact-button"
                    >{{ 'mijn-feedback.feedbackForm.button-text' | apContent }}
                </ap-button>
            </p>
        </div>
    }
    <div class="ap-padding-top-6">
        <ap-button type="submit" (onClick)="submitForm()">
            {{ 'mijn-feedback.feedbackForm.submit' | apContent }}
        </ap-button>
        <ap-button type="button" variant="secondary" (onClick)="onCancel()">
            {{ 'mijn-feedback.feedbackForm.cancel' | apContent }}
        </ap-button>
    </div>
</form>
